<template>
  <ul class="absolute top-full right-0 w-fit py-6 px-5 drop-shadow-md rounded-b-md rounded-tl-md bg-white"
      v-if="isVisible">
    <li v-for="accountOption in accountMenuOptionList.filter(opt => opt.show == null || opt.show())">
      <NuxtLink class="flex gap-x-5 items-center whitespace-nowrap" :to="accountOption.path" external>
        <Icon :icon="accountOption.icon" v-if="accountOption.icon"/>
        <span>{{ accountOption.label }}</span>
      </NuxtLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
import Icon from "../atom/icon.vue";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export interface AccountOption {
  label: string;
  path: string;
  icon?: IconDefinition | string;
  show?(): boolean;
}

interface AccountMenuProps {
  accountMenuOptionList: AccountOption[]
  isVisible?: boolean
}

const {
  accountMenuOptionList = [],
  isVisible = false,
} = defineProps<AccountMenuProps>();

</script>
